module.exports = __webpack_public_path__ + "static/img/icon_account_center.e9577ccb.svg";